import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { on } from '@ember/modifier';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import preventDefault from 'volta/helpers/prevent-default';
import stopPropagation from 'volta/helpers/stop-propagation';
import type { TOC } from '@ember/component/template-only';
interface BvUnstyledLinkSignature {
    Args: {
        ariaDescribedBy?: string;
        ariaLabel?: string;
        external?: boolean;
        onClick?: (e: Event) => void;
        text?: string;
        url?: string;
    };
    Blocks: {
        default: [];
    };
    Element: HTMLAnchorElement;
}
const BvUnstyledLinkComponent: TOC<BvUnstyledLinkSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <a
    href={{@url}}
    data-bv-unstyled='true'
    target={{if @external '_blank'}}
    rel={{if @external 'noopener noreferrer'}}
    aria-label={{@ariaLabel}}
    aria-describedby={{@ariaDescribedBy}}
    ...attributes
    {{on 'click' (stopPropagation (preventDefault (optional @onClick)))}}
  >
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{@text}}
    {{/if}}
  </a>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvUnstyledLinkComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        BvUnstyledLink: typeof BvUnstyledLinkComponent;
        'bv-unstyled-link': typeof BvUnstyledLinkComponent;
    }
}
